import type { AreaId, AreaModule } from './area';

import bcIntegration from '../areas/bc-integration/routes';
import claims from '../areas/claims/routes';
import dashboard from '../areas/dashboard/routes';
import devicesPrinting from '../areas/devices-printing/routes';
import exceptions from '../areas/exceptions/routes';
import masterData from '../areas/master-data/routes';
import pickingShipping from '../areas/picking-shipping/routes';
import production from '../areas/production/routes';
import receiving from '../areas/receiving/routes';
import replenishment from '../areas/replenishment/routes';
import salesOrders from '../areas/sales-orders/routes';
import settings from '../areas/settings/routes';
import warehouseCore from '../areas/warehouse-core/routes';

/**
 * THE AREA REGISTRY — every slot is pre-wired (ARCHITECTURE §10).
 *
 * ⚠ MODULE AGENTS: do not edit this file. Your area is already imported here;
 * everything you need to add lives in `src/areas/<your-module>/routes.tsx`.
 * This is the file two parallel agents would both touch, so it is deliberately
 * complete from day one.
 *
 * Registry order only decides the order of same-`order` nav items inside a
 * section; the sidebar's section order lives in `src/app/nav.ts`.
 */
export const areaModules: readonly AreaModule[] = [
  dashboard,
  salesOrders,
  receiving,
  pickingShipping,
  claims,
  warehouseCore,
  replenishment,
  production,
  masterData,
  devicesPrinting,
  bcIntegration,
  exceptions,
  settings,
];

/** Sanity net: a duplicated or missing id silently breaks nav composition. */
export const areaById: ReadonlyMap<AreaId, AreaModule> = new Map(
  areaModules.map((area) => [area.id, area] as const),
);
